var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeMobileShortRemix = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 20 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.046 3.859c.167-.255.455-.255.623 0l4.22 6.418c.247.377.055.983-.312.983h-2.062c0 5.987-4.952 6.58-6.8 6.712q-1.85.132-1.43-.367 3.7-2.743 3.7-6.345h-1.848c-.367 0-.559-.606-.311-.983ZM9.286.028q1.849-.132 1.428.367Q7.016 3.139 7.016 6.74h1.847c.367 0 .559.606.311.983l-4.22 6.418c-.167.255-.455.255-.623 0L.111 7.723c-.247-.377-.055-.983.312-.983h2.062c0-5.987 4.952-6.58 6.8-6.712"
})));
export default SvgYoutubeMobileShortRemix;